/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { CheckImageModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class CheckImagesClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags CheckImages
   * @name CheckImagesGetCheckImage
   * @summary End point to get check images.
   * @request GET:/checkImages/check
   */
  checkImagesGetCheckImage = (
    query?: {
      /** The check image number. */
      checkImageNumber?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CheckImageModelDto, any>({
      path: `/checkImages/check`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CheckImages
   * @name CheckImagesGetDepositSet
   * @summary End point to get deposit images.
   * @request GET:/checkImages/deposit
   */
  checkImagesGetDepositSet = (
    query?: {
      /** The deposit image number. */
      depositImageNumber?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CheckImageModelDto[], any>({
      path: `/checkImages/deposit`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
